import { ref } from 'vue';
import { smoothScroll } from '@/js/utils/smoothScroll.js'
import { wrapperController } from '@/js/controllers/wrapperController.js'

/**
 * Drawer Menu の制御ロジック
 * @returns {Object} drawerMenuの制御メソッドとstateを返す
 */
export function useDrawerMenu() {
    const isOpen = ref(false);
    const bodyElm = document.body;

    function open() {
        bodyElm.classList.add('is-drawer-open');
        wrapperController.fixed();
        bodyElm.classList.remove('is-drawer-close');
        isOpen.value = true;
    }

    function close(callback) {
        bodyElm.classList.add('is-drawer-close');
        setTimeout(() => {
            bodyElm.classList.remove('is-drawer-open');
            bodyElm.classList.remove('is-drawer-close');
            wrapperController.cancelFixed();
            if (typeof callback === 'function') {
                callback();
            }
        }, 750);
        isOpen.value = false;
    }

    function toggle() {
        return isOpen.value ? close() : open();
    }

    /**
     * 同一ページ内のリンク移動時、スムーススクロール後にメニューを閉じる
     * @param {HTMLAnchorElement} linkElement - クリックされたリンク要素
     * @returns {boolean} ページ遷移が必要な場合true
     */
    function moveToPage(linkElement) {
        const linkHref = (linkElement.href.split('#'));
        const currentHref = (location.href.split('#'));

        // 同一ページの場合
        if (linkHref[0] === currentHref[0]) {
            let callback = null;
            if (linkHref[1]) {
                callback = function () {
                    smoothScroll('#' + linkHref[1].replace(/^_/, ''))
                };
            } else {
                callback = function () {
                    smoothScroll('#wrapper')
                };
            }
            close(callback);
            return false;
        }
        return true;
    }

    return {
        isOpen,
        open,
        close,
        toggle,
        moveToPage
    };
}

